import React, { useEffect, useRef } from "react";
import styles from "./IntroHomePage.module.css"
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Intro = () => {
    const textRef = useRef(null);
    const [t] = useTranslation("global");

    useEffect(() => {
        const handleScroll = () => {
            if (!textRef.current) return;
            const rect = textRef.current.getBoundingClientRect();
            const windowHeight = window.innerHeight || document.documentElement.clientHeight;
            if (rect.top < windowHeight - 100) {
                textRef.current.classList.add(styles.visible);
            } else {
                textRef.current.classList.remove(styles.visible);
            }
        };
        window.addEventListener('scroll', handleScroll);
        handleScroll();
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className={styles.intro}>
            <div className={styles.introContainer} style={{ justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                <div className={styles.introTextContainer}>
                    <div className={styles.textContainer} ref={textRef} style={{ margin: 0, textAlign: 'center' }}>
                        <h1 className={styles.introTitle}>{t("home.intro-titulo")}</h1>
                        <p className={styles.introText}>{t("home.intro-texto")}</p>
                        <Link to="/nuestraempresa" style={{textDecoration: 'none'}}>
                            <button className={styles.introBoton}>{t("home.intro-boton")}</button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Intro;